module.exports = __webpack_public_path__ + "static/media/bremont_invictus_bracelet.b3fcbe5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bremont_invictus_bracelet.png
// module id = 115
// module chunks = 0